export const getMovies = (input = "batman") => {
  return (dispatch, getState) => {
    fetch(`https://omdbapi.com/?apikey=62ec20bf&s=${input}`)
      .then((resp) => resp.json())
      .then((data) => {
        const movies = data.Search ? data.Search : ["data not found"];
        dispatch({
          type: "SET_MOVIES",
          payload: {
            movies,
          },
        });
      })
      .catch((err) => {
        console.log("apakah error");
      });
  };
};
